import type { BlockBase, BlockDefinition, BlockSerialized } from '#layers/block-engine/types/block';
import type { BlockConfigHiddenFn } from '../block';

export const blockEditorHooks = {
	isBlockHiddenInLibrary: [] as Array<(payload: Parameters<BlockConfigHiddenFn>[0] & {
		block: BlockBase | BlockDefinition | BlockSerialized;
	}) => boolean | undefined>,
};
